import { __extends } from "tslib";
import { GetBucketVersioningOutput, GetBucketVersioningRequest } from "../models/index";
import { deserializeAws_restXmlGetBucketVersioningCommand, serializeAws_restXmlGetBucketVersioningCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetBucketVersioningCommand = /** @class */ (function (_super) {
    __extends(GetBucketVersioningCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetBucketVersioningCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetBucketVersioningCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetBucketVersioningRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetBucketVersioningOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetBucketVersioningCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlGetBucketVersioningCommand(input, context);
    };
    GetBucketVersioningCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlGetBucketVersioningCommand(output, context);
    };
    return GetBucketVersioningCommand;
}($Command));
export { GetBucketVersioningCommand };
//# sourceMappingURL=GetBucketVersioningCommand.js.map